import CircularProgress from "@mui/material/CircularProgress";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles((theme) => ({
  loading: {
    margin: "25px",
  },
}));

const PageLoading = () => {
  const classes = useStyles();

  return <CircularProgress className={classes.loading} />;
};

export default PageLoading;
